import { NortherPageProps } from "app/common/components/NortherPageProps"
import { NoIndex } from "app/common/components/seo/NoIndex"
import { ToastProvider } from "app/common/components/ToastProvider"
import { justThrow } from "app/common/fp-ts"
import { logException } from "app/common/logging"
import { bindCommon } from "app/common/next"
import { UrlMgr } from "app/common/routes"
import { createSeoMetadata } from "app/common/seo/seoEssentials"
import { getStaticPropsResult } from "app/common/ui/next"
import { toTitleString } from "app/common/web"
import { ContactUsForm } from "app/feedback/components/ContactUsForm"
import BlogLayout from "app/layouts/BlogLayout"
import { BlitzPage, GetStaticProps } from "blitz"
import { LocaleD } from "db"
import { option, task, taskEither } from "fp-ts"
import { pipe } from "fp-ts/function"

interface ContactUsPageProps extends NortherPageProps {
  locale: LocaleD
}

// ts-prune-ignore-next
export const getStaticProps: GetStaticProps<ContactUsPageProps> = ({ locale }) =>
  pipe(
    taskEither.Do,
    bindCommon(locale),
    taskEither.bind("seoMetadata", ({ locale, ogLocale, t }) =>
      pipe(
        {
          canonicalUrl: UrlMgr.Contact({ locale }),
          metaDescription: `Contact Norther to let us know what we got wrong, what we don't know about, or what we can do better.`,
          openGraphMetadata: {
            description: `Contact Norther to let us know what we got wrong, what we don't know about, or what we can do better.`,
            locale: ogLocale,
            siteName: "Norther",
            title: toTitleString([t("contact-us"), t("buy-local-buy-canadian"), `Norther`]),
            type: option.none,
            url: UrlMgr.Contact({ locale }),
          },
          title: toTitleString([t("contact-us"), t("buy-local-buy-canadian"), `Norther`]),
          urlMap: {
            en_ca: UrlMgr.Contact(),
            fr_ca: UrlMgr.Contact({ locale: LocaleD.fr_ca }),
            "x-default": UrlMgr.Contact(),
          },
        },
        createSeoMetadata,
        taskEither.of
      )
    ),
    taskEither.bimap(logException, getStaticPropsResult),
    taskEither.fold(justThrow, task.of)
  )()

const Contact: BlitzPage<ContactUsPageProps> = () => (
  <>
    <NoIndex />
    <ToastProvider>
      <ContactUsForm />
    </ToastProvider>
  </>
)

Contact.suppressFirstRenderFlicker = true

Contact.getLayout = BlogLayout.getLayout

// ts-prune-ignore-next
export default Contact
